import React from 'react';
import Loading from './Loading';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const propTypes = {
  transition: PropTypes.object,
};
class TermOfUse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.iframeDom = React.createRef();
  }
  componentDidMount() {
    const iframe = this.iframeDom.current;
    const th = this;
    if (iframe.attachEvent) {
      iframe.attachEvent('onload', function() {
        th.handleFrameLoad();
      });
    } else {
      iframe.onload = function() {
        th.handleFrameLoad();
      };
    }
  }
  handleFrameLoad = () => {
    /*$("#termOfUse").contents().find(".mobile-header").hide();
        $("#termOfUse").contents().find("#header").hide();
        $("#termOfUse").contents().find("#sidebar").hide();
        $("#termOfUse").contents().find("#footer").hide();*/
    $('#termOfUse')
      .contents()
      .find('#ControlMenu, .portlet-topper, .quick-access-nav')
      .hide();
    this.setState({ loading: false });
    $('#termOfUse').show();
  };
  goBackToReg = () => {
    this.props.transition.router.stateService.go('registrationScreen2', {}, { location: false });
  };
  render() {
    return (
      <Modal backdrop="static" show>
        <button className="btn btn-primary" onClick={this.goBackToReg} style={{ marginBottom: 2 }}>
          Back
        </button>
        {this.state.loading && <Loading show={this.state.loading} />}
        <iframe
          frameBorder="0"
          title="termOfUse"
          height="475px"
          id="termOfUse"
          ref={this.iframeDom}
          src="&#x2f;mobile-terms-of-use"
          style={{ display: 'none' }}
          width="100%"
        />
      </Modal>
    );
  }
}

TermOfUse.propTypes = propTypes;
export default TermOfUse;
